module.exports = __webpack_public_path__ + "assets/word_early_warning_highlight.c794fb90.svg";